<template>
  <div class="public_head">
    <el-container>
      <!-- 头部导航栏 -->
      <el-header>
        <div class="demo-image">
          <!-- <img src="../assets/logo9.png" alt /> -->
          <img :src="idLogo" alt/>
        </div>
        <div class="demo-wenzi">
          低速锂电大数据平台
        </div>
        <div class="right" @click="toggle">
          <div class="item hover-effect" v-if="hasPermission(290)">
            <el-dropdown trigger="click">
              <div class="dp el-dropdown-link" @click="handleLVWODP">
                <div class="iconfont">
                  <img src="../assets/images/dp.png" alt />
                </div>
                <div style="margin-top: -5px">绿沃大屏</div>
              </div>
              <el-dropdown-menu slot="dropdown" :visible-arrow="false"></el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="item hover-effect" v-if="hasPermission(228)">
            <el-dropdown trigger="click">
              <div class="dp el-dropdown-link" @click="hadnleGLMDP">
                <div class="iconfont">
                  <img src="../assets/images/dp.png" alt />
                </div>
                <div style="margin-top: -5px">格林美大屏</div>
              </div>
              <el-dropdown-menu slot="dropdown"></el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="item hover-effect" v-if="hasPermission(736)">
            <el-dropdown trigger="click">
              <div class="dp el-dropdown-link" @click="handleFTDP">
                <div class="iconfont">
                  <img src="../assets/images/dp.png" alt />
                </div>
                <div style="margin-top: -5px">丰田大屏</div>
              </div>
              <el-dropdown-menu slot="dropdown" :visible-arrow="false"></el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="item hover-effect"   v-if="hasPermission(317)">
            <el-dropdown trigger="click" @command="handleBigScreenClick">
              <div class="dp el-dropdown-link">
                <div class="iconfont">
                  <img src="../assets/images/dp.png" alt />
                </div>
                <div style="margin-top: -5px">大屏</div>
              </div>
              <el-dropdown-menu slot="dropdown" class="dropdown-user">
                <el-dropdown-item command="1">
                  <span style="width: 69px;display: inline-block;">菲尼基大屏</span>
                  <svg-icon icon-class="chevron-right" style="font-size: 16px;"></svg-icon>
                </el-dropdown-item>
                <el-dropdown-item command="2" divided>
                  <span style="width: 69px;display: inline-block;">换电大屏</span>
                  <svg-icon icon-class="chevron-right" style="font-size: 16px;"></svg-icon>
                </el-dropdown-item>
                  <el-dropdown-item command="6" divided>
                  <span style="width: 69px;display: inline-block;">租赁大屏</span>
                  <svg-icon icon-class="chevron-right" style="font-size: 16px;"></svg-icon>
                </el-dropdown-item>
                <el-dropdown-item command="3" divided>
                  <span style="width: 69px;display: inline-block;">支付大屏</span>
                  <svg-icon icon-class="chevron-right" style="font-size: 16px;"></svg-icon>
                </el-dropdown-item>
                <!-- <el-dropdown-item command="4" divided >
                  <svg-icon icon-class="yunyingguanli" style="font-size: 18px;margin-right: 5px;"></svg-icon>
                  绿沃大屏</el-dropdown-item>
                <el-dropdown-item command="5" divided>
                  <svg-icon icon-class="yunyingguanli" style="font-size: 18px;margin-right: 5px;"></svg-icon>
                  格林美大屏</el-dropdown-item>
                  <el-dropdown-item command="7" divided>
                  <svg-icon icon-class="yunyingguanli" style="font-size: 18px;margin-right: 5px;"></svg-icon>
                  丰田大屏</el-dropdown-item> -->
              </el-dropdown-menu>
            </el-dropdown>
          </div>



          <div class="item hover-effect">
            <el-dropdown trigger="click" @command="handleCommand">
              <div class="dp el-dropdown-link">
                <div class="iconfont">
                  <img src="../assets/images/list.png" alt />
                </div>
                <div style="margin-top: -5px">{{username}}</div>
              </div>
              <el-dropdown-menu slot="dropdown" class="dropdown-user">
                <el-dropdown-item command="3" divided class="alarmTip" >

                   <div class="btn-text" style="width:56px;margin-right:8px;float:left">告警提示</div>
                   <div class="control-btn" @click="handleAlarm()">
                    <img :src="require('@/assets/openBtn.png')" alt="" v-if="alarmBtn">
                    <img :src="require('@/assets/offBtn.png')" alt="" v-else>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item command="1"><span style="width:56px;display: inline-block;">修改密码</span></el-dropdown-item>
                <el-dropdown-item command="2" divided><span style="width: 56px;display: inline-block;">退出登录</span></el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>


          <!-- <div class="item hover-effect" style="margin-right: 0px">
            <el-dropdown trigger="click" @command="handleChangeTheme">
              <div class="dp el-dropdown-link" style="margin-right: 0px">
                <div class="iconfont" style="">
                  <svg-icon icon-class="gengduo" style="font-size: 20px"></svg-icon>
                </div>

              </div>
              <el-dropdown-menu slot="dropdown">

                <el-dropdown-item command="theme2">
                  <div style="display: flex;align-items: center">
                    <svg-icon icon-class="chuantonghei" style="font-size: 18px;margin-right: 5px;"></svg-icon>
                    传统黑
                  </div>

                </el-dropdown-item>

                <el-dropdown-item command="theme1">
                  <div style="display: flex;align-items: center">
                    <svg-icon icon-class="keji" style="font-size: 22px;margin-left: -3px;margin-right: 5px"></svg-icon>
                    科技蓝
                  </div>
                </el-dropdown-item>

                <el-dropdown-item command="theme2_skyblue">
                  <div style="display: flex;align-items: center">
                    <svg-icon icon-class="baicai" style="font-size: 14px;margin-left: 0px;margin-right: 10px"></svg-icon>
                    极光白
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div> -->

        </div>
        <div class="tanchuang">
          <el-dialog v-dialogDrag  title="修改密码" :visible.sync="dialogVisible" width="35%" :modal-append-to-body="false">
            <el-form
              :model="ruleForm"
              status-icon
              :rules="rules"
              ref="ruleForm"
              label-width="150px"
              class="demo-ruleForm"
            >
              <el-form-item label="请输入原密码" prop="pass">
                <el-input v-model="ruleForm.pass" placeholder="请输入原密码"></el-input>
              </el-form-item>
              <el-form-item label="请输入新密码" prop="newPass">
                <el-input v-model="ruleForm.newPass" placeholder="请输入新密码"></el-input>
              </el-form-item>
              <el-form-item label="请确认新密码" prop="checkPass">
                <el-input v-model="ruleForm.checkPass" placeholder="请再次输入新密码"></el-input>
              </el-form-item>
            </el-form>
             <div slot="footer" class="dialog-footer">
               <el-button class="dialogBtn" type="primary" @click="submitForm('ruleForm'),dialogVisible == false">确 定</el-button>
             </div>
          </el-dialog>
        </div>
      </el-header>
    </el-container>
    <div class="headColor"></div>
    <Alarmtips ref='alarmtips'></Alarmtips>
  </div>
</template>
<style lang="scss" scoped>

  .headColor {

    [data-theme="theme1"] & {
      width: 100%;
      height: 3px;
      background: linear-gradient(270deg, rgba(0, 255, 245, 0) 0%, rgba(0, 255, 246, 1) 50%, rgba(0, 128, 123, 0) 100%);
    }


  }

  .el-header {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    // align-items: center;
    justify-content: flex-start;
    width: 100%;
    height:64px !important;
    padding: 0 !important;
    color: #10152D;
    background: #FFFFFF;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    position: relative;
    z-index: 1999 ;
    // background: linear-gradient(to right, #48D0FF, #1167E9);/*标准语法*/
    // box-shadow:0px 7px 10px rgba(47, 106, 196 ,0.8) ;

    // background: -webkit-linear-gradient(left, #48D0FF, #1167E9); /* Safari 5.1 - 6.0 */
    // background: -o-linear-gradient(right,#48D0FF, #1167E9); /* Opera 11.1 - 12.0 */
    // background: -moz-linear-gradient(right, #48D0FF, #1167E9); /* Firefox 3.6 - 15 */
  }

  [data-theme="theme2_skyblue"]
  .el-header{
    background: linear-gradient(to left,rgb(72, 173, 255), #1167E9);
    box-shadow:0px 6px 20px rgba(19,107,234 ,0.5) ;
  }

  .demo-image {
    width:232px;
    height:64px;
    display: flex;
    align-items: center;
    justify-content: center;
    img{
      width:150px;
      max-height:64px;
    }
  }

  .demo-wenzi {
    font-size: 24px;
    font-family: AlimamaShuHeiTi-Bold, AlimamaShuHeiTi;
    font-weight: bold;
    color: #10152D;
    line-height: 28px;
    letter-spacing: 1px;
    margin-top: 20px;
    /*margin-left: 24px;*/
  }

  .el-dropdown-link {
    cursor: pointer;
  }

  .el-dropdown-link:focus {
    outline: none;
  }

  .right {
    display: flex;
    position: absolute;
    right:24px;
    top: 5px;
    cursor: pointer;
    text-align: right;

    .item {


      margin-left: 16px;

      /*line-height: 60px;*/
      .iconfont {
        height: 40px;
        width: 40px;
        img{
          width: 100%;
          height: 100%;
        }
      }

      .dp {
        display: flex;
        flex-direction: column;
        align-items: center;
        div {
          font-size: 14px;
        }
      }
    }

    .hover-effect {
      cursor: pointer;
      transition: background 0.3s;

    }
  }

  .twochange {
    width: 150px;
    height: 100px;
    z-index: 1000;
    position: absolute;
    left: 0;
  }

  .change {
    border: 1px solid #cccccc;
    width: 150px;
    height: 25px;
    line-height: 25px;
    background: inherit;
    background-color: rgb(25, 34, 48);

    border-radius: 0px;
    display: block;
    padding: 0;
    color: #ffffff;
    text-align: center;
  }

  .end {
    border-radius: 24px;
    width: 88px;
    height: 32px;
    font-size: 14px;
    line-height: 7px;
    background: rgba(8, 107, 175, 0.99);
    color: rgb(255, 255, 255);
    position: absolute;
    right: -25%;
    border: none;
  }
  // 提醒控制
  .dropdown-user{
    .el-dropdown-menu__item{
      padding: 0 16px!important;
      line-height: 40px!important;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #10152D;
      line-height: 24px;
    }
    .el-dropdown-menu__item--divided{
      margin-top: 0px;
      border: none;
      &:before{
        height: 0px;
      }
    }

    .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover{
      background-color: #F5F9FF;
      color: #0066FF;
    }
    .alarmTip{
    // padding: 0px 10px!important;
   &:before {
      margin: 0 -10px!important;
    }
    .control-btn{
    width: 36px;
    height: 40px;
    float: left;
    line-height: 45px;
    img{
      width: 36px;
      height: 20px;
      // padding-right: 10px;
    }
  }
  }
  }
.dropdown-user.el-dropdown-menu{
  box-shadow: 0px 2px 16px 0px rgba(182,186,193,0.3);
  border-radius: 3px;
  padding: 8px 0;
}
</style>
<script>
    import router from "../router";
    import {findSIM, importXlxSIM} from "@/services/inventory";
    import Alarmtips from "./Alarmtips/index";
    import {EventBus} from '@/utils/event-bus';
    import {getUserId} from "@/utils/auth";
    import {loadLogo} from "@/services/role";
    import {isPasswordValid} from '@/utils/validate.js'
    export default {
      components:{Alarmtips},
        data() {
            let regPass = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/;
            var validatePass = (rule, value, callback) => {
                if (value === "" ||  !isPasswordValid(value)) {
                    callback(new Error("请输入8位以上的数字、字母、特殊字符中任意两类的组合"));
                } else {
                    if (this.ruleForm.checkPass !== "") {
                        this.$refs.ruleForm.validateField("checkPass");
                    }
                    callback();
                }
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === "") {
                    callback(new Error("请再次输入密码"));
                } else if (value !== this.ruleForm.newPass) {
                    callback(new Error("两次输入密码不一致!"));
                } else {
                    callback();
                }
            };
            return {
                head1: require("../assets/head1.png"),
                head2: require("../assets/head2.png"),
                head3: require("../assets/head3.png"),
                url: require("../assets/header.png"),
                idLogo: null,
                isshow1: false,
                isshow: false,
                username: "",
                dialogVisible: false,
                ruleForm: {
                    pass: "",
                    newPass: "",
                    checkPass: ""
                },
                rules: {
                    pass: [{required: true, message: "请输入密码", trigger: "blur"}],
                    newPass: [{required: true, validator: validatePass, trigger: "blur"}],
                    checkPass: [
                        {required: true, validator: validatePass2, trigger: "blur"}
                    ]
                },
                roleData: "",
                arr1: [],
                alarmBtn:true
            };
        },
        methods: {
            //权限控制
            hasPermission(id) {
                return this.$store.getters.hasPermission(id);
            },
               // 大屏（下拉展示）
          hadnleMixBigData(){
             let routeUrl = this.$router.resolve({
                    path: "/dashboard/hadnleMixData"
                });
                window.open(routeUrl.href, "_blank");
          },
            hadnlePay() {
                let routeUrl = this.$router.resolve({
                    path: "/dashboard/pay"
                });
                window.open(routeUrl.href, "_blank");
            },
            handleDP() {
                let routeUrl = this.$router.resolve({
                    path: "/dashboard/analysis"
                });
                window.open(routeUrl.href, "_blank");
            },
            handleLeaseDP() {
                let routeUrl = this.$router.resolve({
                    path: "/dashboard/analysis2"
                });
                window.open(routeUrl.href, "_blank");
            },
            handleFTDP(){
              let routeUrl = this.$router.resolve({
                    path: "/ft/bigData"
                });
                window.open(routeUrl.href, "_blank");
            },
            handleLVWODP() {
                let routeUrl = this.$router.resolve({
                    path: "/dashboard/lvwoAnalysis"
                });
                window.open(routeUrl.href, "_blank");
            },
             //格林美运营大屏
             hadnleGLMDP() {
                let routeUrl = this.$router.resolve({
                    path: "/dashboard/greenBeauty"
                });
                window.open(routeUrl.href, "_blank");
            },


            handleBigScreenClick(type) {
                type=Number.parseInt(type);
                switch (type) {
                    case 1:
                        this.hadnleMixBigData();
                        break;
                    case 2:
                        this.handleDP();
                        break;
                    case 3:
                        this.hadnlePay();
                        break;
                    case 4:
                        this.handleLVWODP();
                        break;
                    case 5:
                        this.hadnleGLMDP();
                        break;
                    case 6:
                        this.handleLeaseDP();
                        break;
                    case 7:
                      this.handleFTDP();
                      break;
                }
            },

            handleCommand(type) {
                if (type == 1) {
                    this.dialogVisible = true;
                } else if (type == 2) {
                    this.logOut();
                }
            }, handleChangeTheme(theme) {
                window.document.documentElement.setAttribute('data-theme', theme)
                localStorage.setItem("theme", theme);
                this.$store.dispatch('settings/changeSetting', {
                    key: 'theme',
                    value: theme
                })
            },

            toggle() {
                this.isshow = !this.isshow; //取反
            },

            // handleClose(done) {
            //   this.dialogVisible = false;
            // },
            // 退出登录
            logOut() {
                // console.log("退出登录");
                this.$axios.post("/user/logout").then(result => {
                    // console.log(result.data);
                    sessionStorage.removeItem("token");
                    if (result.data.code == 0) {
                        // this.$store.getters.permission = []
                        this.$store.dispatch('permission/setPermission', [])
                        // console.log(this.$store,22)
                        EventBus.$emit("closeConnect"); //断开连接

                        if(localStorage.getItem("loginPath")=='/ft/login'){
                          this.$router.push({path: "/ft/login"});
                        }else{
                          this.$router.push({path: "/"});
                        }

                        window.location.reload(); //清空上一个登录账号的路由信息

                        this.$message({
                            message: "退出登录",
                            type: "success",
                            showClose: true,
                            duration: 2000
                        });

                    }
                });
            },
            // 修改密码
            submitForm(formName) {
                let regPass = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/;
                // console.log(this.ruleForm.pass);
                // console.log(this.ruleForm.newPass);
                // console.log(this.ruleForm.checkPass);
                if (
                    this.ruleForm.newPass != this.ruleForm.checkPass ||
                     !isPasswordValid(this.ruleForm.newPass)  ||
                    this.ruleForm.pass == "" ||
                    this.ruleForm.pass == " "
                ) {
                    this.$refs[formName].validate(valid => {
                    });
                    this.dialogVisible = true;
                    this.$message({
                        message: "密码修改不成功！",
                        type: "error",
                        showClose: true,
                        duration: 2000
                    });
                } else {
                    let upData = {
                        oldPassword: this.ruleForm.pass, //唯一标识符，让其知道是在修改这条数据
                        newPassword: this.ruleForm.newPass
                    };
                    // console.log(upData);
                    this.$axios
                        .post(
                            "/user/updatePassword?oldPassword=" +
                            this.ruleForm.pass +
                            "&newPassword=" +
                            this.ruleForm.newPass
                        )
                        .then(result => {
                            // console.log(result.data);
                            if (result.data.code == 0) {
                                this.$message({
                                    message: "恭喜你，密码修改成功",
                                    type: "success",
                                    showClose: true,
                                    duration: 2000
                                });

                                this.dialogVisible = false;
                                this.logOut();
                                $(".twochange").hide();
                            } else {
                                this.$message({
                                    message:result.data.data,
                                    type: "error",
                                    showClose: true,
                                    duration: 5000
                                }); 
                            }
                        });
                }
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            idlogo() {
                if(sessionStorage.getItem("loginName")=="DLXNY001"){
                    this.idLogo ="http://fnjkj.oss-cn-beijing.aliyuncs.com/images1/1618366065981.png";
                    return;
                }

                let logo= localStorage.getItem("logo");
                if(logo){
                    this.idLogo =logo;
                }else{
                    this.idLogo = require("../assets/images/fnj-logo.png");
                }
                loadLogo().then(res=>{
                     if(res){
                         localStorage.setItem("logo",res.data)
                     }else{
                         localStorage.setItem("logo","")
                     }
                    let logo= localStorage.getItem("logo");
                    if(logo){
                        this.idLogo =logo;
                    }else{
                        this.idLogo = require("../assets/images/fnj-logo.png");
                    }
                });

               // this.idLogo = require("../assets/images/fnj-logo.png");

               /* let than = this;
                than.$axios
                    .post("/operatorController/selectByOperatorPic")
                    .then(res => {
                        // console.log(res.data.data)
                        than.idLogo = res.data.data;
                        let smg = "该用户运营商未添加logo";
                        if (this.idLogo == smg) {
                            this.idLogo = require("../assets/fnj002.png");
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    });*/
            },
        // 提醒设置
        handleAlarm(){
          this.alarmBtn=!this.alarmBtn;
          // console.log(this.alarmBtn)
          if(this.alarmBtn==true){
            // 开启告警推送，调用推送的函数
            // 弹窗出现
            localStorage.setItem("is_receive",true)  //接收消息
            EventBus.$emit("connect",getUserId())  // 开始连接,传useid过去
          }else {
             localStorage.setItem("is_receive",false)  //不接消息
             EventBus.$emit("closeConnect")  //断开连接
            // 弹窗关闭
          }
        }
        },
        created() {
            var than = this;
            this.username = sessionStorage.getItem("username");
            let isReceive= localStorage.getItem("is_receive");

            if(!(isReceive=='false')){
              this.alarmBtn=true
            }else{
              this.alarmBtn=false;
            }
            // this.dpshow()
        },
        mounted() {
            this.idlogo();
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/Head.vue